import { InjectionToken } from '@angular/core';
import { IConfig } from 'unleash-proxy-client';

type UnleashConfig = Omit<IConfig, 'url'> & {
    /** If set to `true`, you will need to manually trigger start later in your application lifetime. */
    lazyStart?: boolean;
    url?: string;
};

export type FeatureFlagsConfig =
    | ({ enabled: boolean } & UnleashConfig)
    | ({ enabled: false } & Partial<UnleashConfig>)
    | ({ enabled: true } & UnleashConfig);

export const FEATURE_FLAGS_CONFIG = new InjectionToken<FeatureFlagsConfig>('feature_flags_config');
